<template lang="jade">
  .container
    .row.well
      .row
        .col-md-6.col-md-offset-3.center-element
          label.to-click
            input(type="radio", v-model="filterBy", id="Locais de trabalho" value="companies")
            | Locais de trabalho &nbsp;
          label.to-click
            input(type="radio", v-model="filterBy", id="Funcionários" value="employees")
            | Funcionários &nbsp;
          label.to-click
            input(type="radio", v-model="filterBy", id="Grupos" value="groups")
            | Grupos &nbsp;
      .row
        .col-md-12(v-if="filterBy == 'companies'")
          MultiSelect(filterText="filtrar locais de trabalho", :callback="loadCompanies", useState="statusSheets/companies",
            key="companies", minHeight="200")
        .col-md-12(v-if="filterBy == 'employees'")
          MultiSelect(filterText="filtrar funcionários", :callback="loadEmployees", useState="statusSheets/employees",
            key="employees", minHeight="200")
        .col-md-12(v-if="filterBy == 'groups'")
          MultiSelect(filterText="filtrar grupos", :callback="loadGroups", useState="statusSheets/groups",
          key="groups", minHeight="200")
        .col-md-12
          br
          UniqueSelect(filterText="Selecione uma data", useState="statusSheets/dates", :callback="getDates", :parseField="parseDate")
      .row
        .col-md-12.center-element
          button.btn.btn3d.btn-md.btn-success(@click="loadStatus", :disabled="!valid") Buscar
      .row
        .col-md-12.center-element
          .breadcrumb.flat
            a(v-for="item in header", :class="{'active': searchStatus.selected && (searchStatus.selected.id === item.type || searchStatus.selected.id == 'all')}",
            @click="showOnlyStage(item.type)") {{ item.name }}: {{ item.total }} ({{ item.percent }}%)

          StatusSheetsList

</template>

<script>
import MultiSelect from '../../common/MultiSelect/MultiSelect.vue'
import UniqueSelect from '../../common/UniqueSelect/UniqueSelect.vue'
import { handleRequest } from '../../services'
import { mapGetters } from 'vuex'
import StatusSheetsList from './StatusSheetsList/StatusSheetsList.vue'
import moment from 'moment'

export default {
  computed: {
    ...mapGetters('statusSheets', ['loading', 'statesList', 'searchStatus']),
    filterBy: {
      get () { return this.$store.getters['statusSheets/filterBy'] },
      set (newVal) { this.$store.dispatch('statusSheets/filterBy', newVal) }
    },
    stagesPrettyNames () {
      return {
        'not_gen': 'Não Geradas',
        'not_scan': 'Não Escan.',
        'not_proc': 'Não Proces.',
        'not_verified': 'Não Verificadas',
        'ignored': 'Ignoradas',
        'verified': 'Verificadas'
      }
    },
    valid () {
      const empsSel = this.$store.getters['statusSheets/employees'].selected
      const groupsSel = this.$store.getters['statusSheets/groups'].selected
      const compsSel = this.$store.getters['statusSheets/companies'].selected
      const dates = this.$store.getters['statusSheets/dates']
      return ((empsSel && empsSel.length && this.filterBy === 'employees') ||
             (compsSel && compsSel.length && this.filterBy === 'companies') ||
             (groupsSel && groupsSel.length && this.filterBy === 'groups')) && (dates && dates.selected)
    },
    header () {
      const calcTotal = (status) => {
        const total = this.statesList.filter(i => i.status.type === status).length
        return {
          name: this.stagesPrettyNames[status],
          total,
          type: status,
          percent: this.statesList.length && total ? Math.round((100 * total) / this.statesList.length) : 0
        }
      }
      return ['not_gen', 'not_scan', 'not_proc', 'not_verified', 'ignored', 'verified'].map(i => calcTotal(i))
    }
  },
  methods: {
    formatFiltered (item) {
      return item.employee.name
    },
    loadCompanies (options) {
      return this.$API.company.get({...options, fields: JSON.stringify(['id', 'name']), 'order_by': 'name'})
    },
    loadGroups (options) {
      return this.$API.userGroups.get({...options, 'order_by': 'name'})
    },
    loadEmployees (options) {
      return this.$API.employee.get({...options, fields: JSON.stringify(['id', 'name']), 'order_by': 'name'})
    },
    parseDate (date) {
      if (!date) { return '' }
      const month = date[date.length - 2] + date[date.length - 1]
      const year = date[0] + date[1] + date[2] + date[3]
      return moment().year(year).month(month).format('MMMM YYYY')
    },
    async getDates () {
      const result = await handleRequest.api('sheet', null, {open_months: true})
      return {body: {success: result.data.map(i => { return {id: i, name: i} })}}
    },
    loadStatus () {
      this.$store.dispatch('statusSheets/getStatusSheets')
    },
    goToSheet (item) {
      this.$router.push(`sheet-checker/${item.sheet.uuid}`)
    },
    customSearchStatus (search, loaded) {
      const result = loaded.filter(i => {
        return !search || i.employee.name.toLowerCase().includes(search.toLowerCase()) ||
          (i.employee.code && i.employee.code.includes(search.toLowerCase()))
      })
      return result
    },
    showOnlyStage (status) {
      this.$store.dispatch('statusSheets/searchStatus', {selected: {id: status, name: this.stagesPrettyNames[status]}})
    }
  },
  components: { MultiSelect, UniqueSelect, StatusSheetsList }
}
</script>

<style scoped>
  .breadcrumb {
    overflow: hidden;
    background: none;
    width: 100%;
    padding: 0;
    margin: 15px 0px 15px 0px;
  }
  .breadcrumb a {
    text-decoration: none;
    text-align: center;
    outline: none;
    display: block;
    width: 16.666%;
    float: left;
    font-size: 13.8px;
    line-height: 36px;
    color: #acacac;
    /*need more margin on the left of links to accomodate the numbers*/
    position: relative;
  }
  /*since the first link does not have a triangle before it we can reduce the left padding to make it look consistent with other links*/
  .breadcrumb a:first-child {
    border-radius: 5px 0 0 5px; /*to match with the parent's radius*/
  }
  .breadcrumb a:first-child:before {
    left: 14px;
  }
  .breadcrumb a:last-child {
    border-radius: 0 5px 5px 0; /*this was to prevent glitches on hover*/
  }

  /*hover/active styles*/
  .breadcrumb a.active, .breadcrumb a:hover{
    background: rgb(61, 138, 161);
  }
  .breadcrumb a.active:after, .breadcrumb a:hover:after {
    background: rgb(61, 138, 161);
  }

  /*adding the arrows for the breadcrumbs using rotated pseudo elements*/
  .breadcrumb a:after {
    content: '';
    position: absolute;
    top: 0;
    right: -9px; /*half of square's length*/
    /*same dimension as the line-height of .breadcrumb a */
    width: 36px;
    height: 36px;
    /*as you see the rotated square takes a larger height. which makes it tough to position it properly. So we are going to scale it down so that the diagonals become equal to the line-height of the link. We scale it to 70.7% because if square's:
      length = 1; diagonal = (1^2 + 1^2)^0.5 = 1.414 (pythagoras theorem)
      if diagonal required = 1; length = 1/1.414 = 0.707*/
    transform: scale(0.707) rotate(45deg);
    /*we need to prevent the arrows from getting buried under the next link*/
    z-index: 1;
    /*background same as links but the gradient will be rotated to compensate with the transform applied*/
    background: #666;
    background: linear-gradient(135deg, #666, #333);
    /*stylish arrow design using box shadow*/
    box-shadow:
      2px -2px 0 2px white,
      3px -3px 0 2px rgba(255, 255, 255, 0.1);
    /*
          5px - for rounded arrows and
          50px - to prevent hover glitches on the border created using shadows*/
    border-radius: 0 5px 0 50px;
  }
  /*we dont need an arrow after the last link*/
  .breadcrumb a:last-child:after {
    content: none;
  }

  .flat a, .flat a:after {
    background: #acacac;
    color: white;
    transition: all 0.5s;
  }
  .flat a:before {
    background: #acacac;
    box-shadow: 0 0 0 1px #ccc;
  }
  .flat a:hover, .flat a.active,
  .flat a:hover:after, .flat a.active:after{
    background: rgb(76, 182, 213);
  }
</style>



// WEBPACK FOOTER //
// StatusSheets.vue?0931b240